import "@/index.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Requisitions from "@/pages/Requisitions";
import RequisitionNew from "@/pages/RequisitionNew";
import RequisitionDetail from "@/pages/RequisitionDetail";
import CandidatePipeline from "@/pages/CandidatePipeline";
import CandidateDetail from "@/pages/CandidateDetail";
import Candidates from "@/pages/Candidates";
import EmailSettings from "@/pages/EmailSettings";
import Activity from "@/pages/Activity";
import Reports from "@/pages/Reports";
import Roster from "@/pages/Roster";
import EmployeesList from "@/pages/EmployeesList";
import EmployeeDetail from "@/pages/EmployeeDetail";
import EmployeeOnboarding from "@/pages/EmployeeOnboarding";
import EmployeeExit from "@/pages/EmployeeExit";
import SystemNotifications from "@/pages/SystemNotifications";
import UsersAdmin from "@/pages/UsersAdmin";
import PublicApply from "@/pages/PublicApply";
import RaiseRequisitionPublic from "@/pages/RaiseRequisitionPublic";
import PublicFeedback from "@/pages/PublicFeedback";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-quiet">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/apply/:publicId" element={<PublicApply />} />
          <Route path="/raise/:token" element={<RaiseRequisitionPublic />} />
          <Route path="/feedback/:token" element={<PublicFeedback />} />

          <Route
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/requisitions" element={<Requisitions />} />
            <Route path="/requisitions/new" element={<RequisitionNew />} />
            <Route path="/requisitions/:id" element={<RequisitionDetail />} />
            <Route path="/candidates" element={<CandidatePipeline />} />
            <Route path="/applicants" element={<Candidates />} />
            <Route path="/candidates/:id" element={<CandidateDetail />} />
            <Route path="/activity" element={<Activity />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/roster" element={<Roster />} />
            <Route path="/employees" element={<EmployeesList />} />
            <Route path="/employees/onboarding/:employeeDbId" element={<EmployeeOnboarding />} />
            <Route path="/employees/:employeeDbId/exit" element={<EmployeeExit />} />
            <Route path="/employees/:employeeDbId" element={<EmployeeDetail />} />
            <Route path="/settings/users" element={<UsersAdmin />} />
            <Route path="/settings/email" element={<EmailSettings />} />
            <Route path="/settings/notifications" element={<SystemNotifications />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
